/* global autoComplete */
"use strict";

($dt => {

	let schools = false;

	const load_schools_from_json = (on_success, on_fail) => {
		const url = $dt.school_list;
		if (url) {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.responseType = 'json';
			xhr.onload = () => {
				if (xhr.status === 200) {
					on_success(xhr.response);
				} else {
					on_fail();
				}
			};
			xhr.send();
		} else {
			on_fail();
		}
	};

	const load_schools_from_ajax = (on_success, on_fail) => {
		const xhr = new XMLHttpRequest();
		xhr.open('POST', $dt.ajax_url);
		//xhr.withCredentials = true;
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.responseType = 'json';
		xhr.onload = () => {
			if (xhr.status === 200) {
				on_success(xhr.response);
			} else {
				on_fail();
			}
		};
		xhr.send('action=dc_eduprograms_export_schools_json');
	};

	const controller = {
		
		GetSchools: on_schools_loaded => {
			if (schools === false) {
				// First attempt json file indicated by theme js vars
				load_schools_from_json(on_schools_loaded, () => {
					// If the json file isn't available, which could happen in certain caching scenarios, retrieve the schools via AJAX
					load_schools_from_ajax(schools => {
						console.warn('Forced to load schools via AJAX.');
						on_schools_loaded(schools);
					}, () => {
						console.error('Could not load schools through JSON or AJAX!');
					});
				});
			} else {
				// Schools have already been loaded once on this page request
				on_schools_loaded(schools);
			}
		},

		CreateNewSchoolAutoCompleter: (input_elem, on_autocomplete_prepared) => {
			const { htmlDecode } = $dt.Util;

			const auto_object = {
				autocomplete: false,
				current_id: false,
				Init: () => {
					const field_wrapper_elem = input_elem.parentElement;
					controller.GetSchools(schools => {

						const preselect_id = input_elem.value;
						if (preselect_id.length > 0) {
							// Attempt to preselect school
							try {
								const preselect_int = parseInt(preselect_id);
								if (preselect_int > 0) {
									const preselect_school = schools.find(s => { return s.ID == preselect_int; });
									if (preselect_school) {
										auto_object.current_id = preselect_int;
										input_elem.value = htmlDecode(preselect_school.Name);
									}
								}
							} catch (error) {
								console.warn('Unable to preselect school due to invalid ID.');
							}
						}

						const config = {
							selector: () => { return input_elem; },
							data: {
								src: schools,
								keys: [ 'Name' ]
							},
							resultsList: {
								element: (list, data) => {
									if (!data.results.length) {
										// Create "No Results" message element
										const message = document.createElement("div");
										// Add class to the created element
										message.setAttribute("class", "no_result");
										// Add message text content
										message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;
										// Append message element to the results list
										list.prepend(message);
									}
								},
								noResults: true,
								maxResults: 30
							},
							resultItem: {
								highlight: true
							},
							events: {
								input: {
									selection: event => {
										const selection = event.detail.selection.value;
										input_elem.value = htmlDecode(selection.Name);
										auto_object.current_id = parseInt(selection.ID);

										input_elem.classList.remove('invalid');
										field_wrapper_elem.classList.remove('d3df_invalid');
									},
									keyup: event => {
										// We'll try to determine if the user interacted in a way that should reset their selection to avoid confusion.
										let reset = false;
										if (event.key !== undefined) {
											if (!["Tab", "Enter", "ArrowLeft", "ArrowRight"].includes(event.key)) {
												reset = true;
											}
										} else if (event.keyCode !== undefined) {
											if (![9, 13, 37, 39].includes(event.keyCode)) {
												reset = true;
											}
										} else {
											reset = true;
										}

										if (reset) {
											auto_object.current_id = false;
											input_elem.classList.add('invalid');
										}
									}
								}
							}
						};
		
						auto_object.autocomplete = new autoComplete(config);
						if (typeof(on_autocomplete_prepared) !== 'undefined') {
							on_autocomplete_prepared(auto_object);
						}
					});
				}
			};

			auto_object.Init();
			return auto_object;
		}
	};

	$dt.Schools = controller;
})(window.d3_wp_themejs);
